import NewItemTransfer from "../../../../components/@documents/item_transfers/NewItemTransfer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransferNewPage() {

    return (
        <NewItemTransfer 
            routeType={routeTypes.admin}
        />
    )
}